module.exports = __webpack_public_path__ + "img/adop-img1.04556395.jpg";